module.exports = __webpack_public_path__ + "img/rocketleague_header-image_1920x1080.f4e401e9.jpeg";